import React, { useState ,useEffect} from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import StockListLayer from "../components/StockListLayer";
import { API_URL } from "..";
import { Spinner } from "react-bootstrap";




const StockListPage = () => {

  const [data, setData]=useState([])
  const [loading, setLoading]=useState(false)
  const fetchInvoices =  async()=>{
    setLoading(true)
      const user = JSON.parse(localStorage.getItem('user'));
      if(!user){
        window.location.href='/sign-in'
      }else{
        let headersList = {
          "Accept": "*/*",
          "Content-Type": "application/json"
         }
        let response = await fetch( API_URL+`/api/invoice/stock/fetch`, { 
          method: "GET",
          headers: headersList
        });
        const data = await response.json();
        setLoading(false)
        console.log(data)
        setData(data.stock)
      }
      
  }
  useEffect(()=>{
    fetchInvoices();
  },[1])
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Stock - List" />

        {/* InvoiceListLayer */}
        {
          loading ===true ?
          <div className="text-center mt-4">
            <Spinner/>
          </div>:null
        }
        {
          data.length === 0 && loading ===false ?
          <div className="text-center mt-4">
            <p>No Stock data found....</p>
          </div>:null
        }
        {
          data.length== 0 ? null :
          <StockListLayer jobsData={data}/>
        }

      </MasterLayout>

    </>
  );
};

export default StockListPage;
